import React from "react";
import { Card } from "primereact/card";
import "./shareholder-form.scss";
import PermissionGate from "~/components/PermissionGate";
import { Button } from "primereact/button";
import { useParams } from "react-router-dom";
import { useShareHolderDetails } from "./ShareHolderDetail";
import useShareHolderPersonalInfo from "./useShareHolderPersonalInfo";
import ShareholderInformationWrapper from "./ShareholderInformationWrapper";
import Notification from "../entities/notification/Notification";
import AuditSidebar from "../audit-sidebar/AuditSidebar";
import API_ROUTES from "../../api-routes";
const ShareHolderPersonalInfo = () => {
  const { entityId } = useParams<{ entityId: string }>();
  const { type, resetRegData } = useShareHolderDetails();
  const {
    regData,
    isEditing,
    localSetRegData,
    isSaveDisabled,
    setIsSaveDisabled,
    isLoading,
    handleEditClick,
    handleDiscardClick,
    handleSaveClick,
    setBtnToggle,
    formDetails,
    setFormDetails,
    setAuditSidebarVisible,
    shareholderType,
    setShareholderType,
    successMessage,
    setSuccessMessage,
    isAuditSidebarVisible,
    btnToggle,
  } = useShareHolderPersonalInfo(type);
  const auditLabels = () => {
    return {
      create: "Shareholder Created",
      update: "Information Updated",
      delete: "Shareholder Deleted",
    };
  };
  return (
    <Card className="shareholder__card personal-info-card">
      <div className="personal-info-container flex justify-content-between align-items-center formgrid grid grid-nogutter">
        <p className="personal-information-heading m-0">
          Shareholder Information
        </p>
        <PermissionGate
          resource="shareholder"
          action="modify"
          resourceAttr={{ entity_id: entityId }}
        >
          <div className="flex gap-3">
            {isEditing ? (
              <div className="flex gap-2">
                <Button className="edit-button" onClick={handleDiscardClick}>
                  Discard
                </Button>
                <Button
                  type="submit"
                  className={`save-changes-btn gap-1 flex-row-reverse ${(btnToggle || isSaveDisabled) && "disable"}`}
                  disabled={btnToggle || isSaveDisabled}
                  onClick={handleSaveClick}
                  loading={isLoading}
                >
                  {"Save Changes"}
                </Button>
              </div>
            ) : (
              <>
                <Button
                  className="edit-button"
                  onClick={() => setAuditSidebarVisible(true)}
                >
                  View History
                  <span className="pi pi-history mb-1 ml-2" />
                </Button>
                <Button
                  className="edit-info-button"
                  onClick={() => {
                    handleEditClick();
                    setIsSaveDisabled(true);
                  }}
                >
                  Edit
                  <span className="pi pi-pencil text-xs ml-2"></span>
                </Button>
              </>
            )}
          </div>
        </PermissionGate>
        <Notification
          successMessage={successMessage}
          setSuccessMessage={setSuccessMessage}
        />
      </div>
      <div className="pl-2 pr-2">
        <ShareholderInformationWrapper
          setBtnToggle={setBtnToggle}
          formDetails={formDetails}
          setFormDetails={setFormDetails}
          regData={regData}
          setRegData={localSetRegData}
          isEditing={isEditing}
          isNewShareholder={false}
          shareholderType={shareholderType}
          setShareholderType={setShareholderType}
          resetRegData={resetRegData}
        />
      </div>
      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Shareholder Information"
          endpoint={API_ROUTES.FETCH_SHAREHOLDERS_AUDIT}
          id={regData?.id}
          objectType="shareholder"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
    </Card>
  );
};

export default ShareHolderPersonalInfo;
